import { IConfig } from '@cian/config/shared';

import { getCianMortgagePromoUrl } from '../../../utils/config';
import { EPromoType, IPromoInfo } from '../../../types/newbuilding/promoInfo';

export const getMortgagePartnerLink = (promo: IPromoInfo | null, config: IConfig) => {
  if (promo?.bank?.isPartner && promo?.promoType !== EPromoType.MaternalCapital) {
    return getCianMortgagePromoUrl(config);
  }

  return null;
};
